import { registerStore } from '../../common/utilsClient/multiReducer';

/**
 * TECH-2730. Only the organisation selection is global now.
 *
 * `currentTemplateId` and `isEditTemplateDialogVisible` existed to drive a
 * modal. The editor is inline in the card, so which message is open is local
 * to the list component and belongs there: it is transient view state, it is
 * meaningless without the list mounted, and keeping it in a persisted global
 * store meant a reload could restore "editing" a row that is no longer on
 * screen.
 */
const store = registerStore({
  path: 'ui.screens.SettingsEmailTemplates',
  initialState: {
    organisationId: null,
  },
});

export const getOrganisationId = store.get('organisationId');
export const setOrganisationId = store.create.set('organisationId');

export default store;
